// @see mylw-nxprod.nexcess-internal.workers.dev
import prodTemplate from './prod';
import type { AppConfigI } from './example';

const nxprod: AppConfigI = {
	...prodTemplate,
	hosts: {
		...prodTemplate.hosts,
		www: 'www.nexcess.com',
	},
	gaTrackerId: 'G-1TWF0K1664',
	gtmContainerId: 'GTM-W9D8J7SW',
	cart: {
		checkoutURL: 'https://www.nexcess.com/cart/checkout',
		configURL: 'https://www.nexcess.com/configuration',
		cookieDomain: 'nexcess.com',
		payPalSystem: 'portal_nx',
		payPalSignUpSystem: 'portal_signup_nx',
	},
	chatConfig: {
		...prodTemplate.chatConfig,
		orgId: '00D30000000pmDy',
		deploymentId: 'Nexcess_Support_Portal_MIAW',
		communityURL:
			'https://liquidweb.my.site.com/ESWNexcessSupportPortal1740149043435',
		scrt2URL: 'https://liquidweb.my.salesforce-scrt.com',
		messagingScriptURL:
			'https://liquidweb.my.site.com/ESWNexcessSupportPortal1740149043435/assets/js/bootstrap.min.js',
		storageDomain: 'nexcess.com',
	},
	openId: {
		...prodTemplate.openId,
		client_id: 'nx-portal',
		authority: 'https://login.nexcess.com',
	},
	theme: 'nexcess',
	brand: 'nexcess',
};

export default nxprod;
